<template>
  <div>
    <div class="row">
      <div class="col-md-12 mt-2 mb-2">
        <b>Details</b>
      </div>
    </div>
    <div
      v-if="booking.airportName !== null"
      class="row"
    >
      <div class="col-md-12 content-list mb-2">
        <b>Airport:</b>
        <span>{{ booking.airportName }}</span>
      </div>
    </div>
    <div class="row">
      <div
        v-if="!hidePriceAndProduct"
        class="col-md-12 content-list mb-2"
      >
        <b>Product:</b>
        <span>{{ booking.name }}</span>
      </div>
    </div>
    <div class="row">
      <div
        v-if="!hidePriceAndProduct"
        class="col-md-12 content-list mb-2"
      >
        <b>Price:</b>
        <span>{{ $n(booking.productPrice, 'currency', languageCode) }}
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 content-list mb-2">
        <b>{{ firstOptionLabel }} Date:</b>
        <span>{{ localDateTime(booking.entryDate) }}
        </span>
      </div>
    </div>
    <div
      v-if="booking.entryDate !== booking.exitDate"
      class="row"
    >
      <div class="col-md-12 content-list mb-2">
        <b>{{ secondOptionLabel }} Date:</b>
        <span>{{ localDateTime(booking.exitDate) }}
        </span>
      </div>
    </div>
    <div class="row">
      <div
        v-if="booking.promoCode"
        class="col-md-12 content-list mb-2"
      >
        <b>Promo Code:</b>
        <span>{{ booking.promoCode }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import moment from 'moment'
export default {
    name: 'BookingSummaryDetails',
    props: {
        booking: {
            default: null
        },
        firstOptionLabel: {
            default: 'Entry'
        },
        secondOptionLabel: {
            default: 'Exit'
        },
        hidePriceAndProduct: {
            default: false,
            type: Boolean
        }
    },
    methods: {
        localDateTime(dateTime) {
            var momentDateTime = moment.utc(dateTime).format('ddd MMM DD YYYY HH:mm:ss')
            var localDateTime = moment(momentDateTime).local().format('ddd MMM DD YYYY HH:mm:ss')

            return localDateTime
        }
    },
    computed: {
        languageCode () {
            var code = this.$store.getters['getLanguageCode']({
                identifier: this.$store.state.airport.selectedAirportId
            })
            if (code !== null) {
                return code
            }
            return 'en-GB'
        }
    }
}
</script>
